import React from "react";
import { ArrowRight } from "lucide-react";
import Solar from "./img/video.mp4";

function Content() {
  return (
    <div className="relative h-[85vh] sm:h-screen w-full overflow-hidden bg-black">

      <video
        src={Solar}
        autoPlay
        loop
        muted
        playsInline
        className="absolute inset-0 w-full h-full object-cover opacity-70 sm:opacity-80"
      />

      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/30 to-black/80 z-10" />

      <div className="relative z-20 h-full flex flex-col items-center justify-center px-4 sm:px-6 text-center">

        <h1 className="text-2xl xs:text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-semibold leading-snug tracking-tight text-white animate-enter-emil delay-100 max-w-3xl">
          We care about
          <span
            className="block mt-1 sm:mt-2 pb-1 bg-clip-text text-transparent"
            style={{
              backgroundImage: 'linear-gradient(135deg, #ffffff 0%, #f3ede6 40%, #d4b88a 100%)'
            }}
          >
            your property.
          </span>
        </h1>

        <div className="mt-6 sm:mt-8 flex items-center gap-3 animate-enter-emil delay-200">
          <a href="#services">
            <button
              className="group px-7 sm:px-8 py-2.5 sm:py-3 rounded-full text-sm font-semibold text-white transition-colors duration-200 flex items-center gap-2 active:scale-[0.97]"
              style={{ background: '#712B35' }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = '#5f2b40';
                e.currentTarget.style.boxShadow = '0 8px 32px rgba(113,43,53,0.45)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = '#712B35';
                e.currentTarget.style.boxShadow = 'none';
              }}
            >
              Explore Solutions
              <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
            </button>
          </a>
          <a href="/contact">
            <button
              className="group px-7 sm:px-8 py-2.5 sm:py-3 rounded-full text-sm font-medium text-white/70 transition-colors duration-200 border border-white/10 hover:border-white/25 hover:text-white flex items-center gap-2 active:scale-[0.97]"
              style={{ background: 'rgba(255,255,255,0.04)' }}
            >
              Get a Quote
            </button>
          </a>
        </div>

        {/* Bottom gradient fade */}
        <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-black to-transparent z-10 pointer-events-none" />
      </div>
    </div>
  );
}

export default Content;
